
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "./../../../Axios.js";
import { toast } from 'react-toastify';
import { defaultDateFormatter } from "../../../Helper/functionHelper.js";


const RequestDetails = () => {
    const navigate = useNavigate();
    const [request, setRequest] = useState({});
    const { requestId } = useParams();

    const [showHistory, setShowHistory] = useState(true);
    const toggleTable = () => {
        setShowHistory(prev => !prev);
    };

    const statuses = [
        {
            value: 0,
            label: 'Requested by employee',
            class: 'text-warning'
        },
        {
            value: 1,
            label: 'Approved by manager',
            class: 'text-success'
        },
        {
            value: 2,
            label: 'Rejected by manager',
            class: 'text-danger'
        },
        {
            value: 3,
            label: 'Approved by admin',
            class: 'text-success'
        },
        {
            value: 4,
            label: 'Rejected by admin',
            class: 'text-danger'
        },
        {
            value: 5,
            label: 'Assigned by Admin',
            class: 'text-success'
        },
        {
            value: 6,
            label: 'Acknowledged by employee',
            class: 'text-success'
        },
        {
            value: 7,
            label: 'Rejected by employee',
            class: 'text-danger'
        },
        {
            value: 8,
            label: 'Cancelled by employee',
            class: 'text-danger'
        },
        {
            value: 9,
            label: 'Return accepted by Admin',
            class: 'text-success'
        },
        {
            value: 10,
            label: 'Sent back by Reporting Manager for clarification',
            class: 'text-warning'
        },
        {
            value: 11,
            label: 'Sent back by Vertical Head for clarification',
            class: 'text-warning'
        },
        {
            value: 12,
            label: 'Sent back by IT Procurement for clarification',
            class: 'text-warning'
        },
        {
            value: 13,
            label: 'Sent back by Finance Head for clarification',
            class: 'text-warning'
        },
        {
            value: 14,
            label: 'Approved by Vertical Head',
            class: 'text-success'
        },
        {
            value: 15,
            label: 'Rejected by Vertical Head',
            class: 'text-danger'
        },
        {
            value: 16,
            label: 'Approved by IT Procurement',
            class: 'text-success'
        },
        {
            value: 17,
            label: 'Rejected by IT Procurement',
            class: 'text-danger'
        },
        {
            value: 18,
            label: 'Approved by Finance Head',
            class: 'text-success'
        },
        {
            value: 19,
            label: 'Rejected by Finance Head',
            class: 'text-danger'
        }
    ];

    const fetchRequests = async () => {
        try {
            const result = await api.get(`/asset-requests/${requestId}`);
            setRequest(result.data.data);
        } catch (err) {
            toast.error(err.response?.data?.error || 'An error occurred. Please try again.', {
                position: "top-right",
                autoClose: 3000,
            });
        }
    }

    useEffect(() => {
        fetchRequests();
    }, [])


    return (
        <div>

            <h1 className="dashboard">
                <button className="btn">
                    <img src="/public/images/icon-home.svg" alt="Home" />
                </button> Request Details <span className="edit float-end "> </span>
                <span className="add float-end">
                    <button onClick={() => navigate('/asset-management/requests')} className="btn btn-secondary btn-sm">
                        <span className="icon"><img src="https://dev.megahrms.com//public/images/back-arrow.svg" /></span>
                        <span className="text">Back</span>
                    </button>
                </span>
            </h1>

            <div className="tab-profile mt-3">
                <div className="content-block">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Employee Name (Code)</div>
                                    <div className="form-info-content">
                                        <span>{request?.user_details?.fullname || '-'}</span>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Reporting Manager</div>
                                    <div className="form-info-content">
                                        <span>{request?.user_details?.reporting_manager_name || '-'}</span>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Vertical Head</div>
                                    <div className="form-info-content">
                                        <span>{request?.user_details?.vertical_head_name || '-'}</span>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Department</div>
                                    <div className="form-info-content">
                                        <span>{request?.user_details?.department || '-'}</span>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Designation</div>
                                    <div className="form-info-content">
                                        <span>{request?.user_details?.designation || '-'}</span>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Request Type</div>
                                    <div className="form-info-content">
                                        <span>{request?.request_type || '-'}</span>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">New Assigned Asset</div>
                                    <div className="form-info-content">
                                        <span>
                                        {request?.asset?.new?.asset_name && request?.asset?.new?.sr_no
                                            ? `${request.asset.new.asset_name} (${request.asset.new.sr_no})`
                                            : '-'}
                                        </span>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Replace/Returned Asset</div>
                                    <div className="form-info-content">
                                        <span>
                                            {request?.asset?.old?.asset_name && request?.asset?.old?.sr_no
                                            ? `${request.asset.old.asset_name} (${request.asset.old.sr_no})`
                                            : '-'}
                                        </span>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Asset Type</div>
                                    <div className="form-info-content">
                                        <span>{request?.asset_type?.type_name || request?.asset?.old?.asset_type?.type_name || '-'}</span>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Remarks</div>
                                    <div className="form-info-content">
                                        <span>{request?.request_remark || '-'}</span>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="form-info">
                                    <div className="form-info-label">Status</div>
                                    <div className="form-info-content">
                                        <span className={statuses.find(s => s.value === request.status)?.class || 'text-secondary'}>
                                            {statuses.find(s => s.value === request.status)?.label || 'Unknown'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tab-profile mt-3">
                <div className="content-block">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2>Asset Detail</h2>
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Asset Type</div>
                                            <div className="form-info-content">
                                                <span>{request?.asset_type?.type_name || request?.asset?.new?.asset_type?.type_name || request?.asset?.old?.asset_type?.type_name || '-'}</span>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Asset Name</div>
                                            <div className="form-info-content">
                                                <span>{request.request_type === "New" ? request?.asset?.new?.asset_name || '-' : request?.asset?.new?.asset_name || request?.asset?.old?.asset_name || '-'}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Serial Number</div>
                                            <div className="form-info-content">
                                                <span>
                                                    {request.request_type === "New" ? request?.asset?.new?.sr_no || '-' : request?.asset?.new?.sr_no || request?.asset?.old?.sr_no || '-'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Maker</div>
                                            <div className="form-info-content">
                                                <span>
                                                    {request.request_type === "New" ? request?.asset?.new?.asset_maker?.maker_name || '-' : request?.asset?.new?.asset_maker?.maker_name || request?.asset?.old?.asset_maker?.maker_name || '-'}
                                                </span>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Description</div>
                                            <div className="form-info-content">
                                                <span>
                                                    {request.request_type === "New" ? request?.asset?.new?.description || '-' : request?.asset?.new?.description || request?.asset?.old?.description || '-'}
                                                </span>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Assigned On</div>
                                            <div className="form-info-content">
                                                <span>
                                                    {/* {defaultDateFormatter(request?.new_assignment?.assigned_date ?? request?.old_assignment?.assigned_date) ?? '-'} */}
                                                    {
                                                    !isNaN(Date.parse(request?.new_assignment?.assigned_date ?? request?.old_assignment?.assigned_date))
                                                        ? defaultDateFormatter(request?.new_assignment?.assigned_date ?? request?.old_assignment?.assigned_date)
                                                        : '-'
                                                    }
                                                </span>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                        <div className="form-info">
                                            <div className="form-info-label">Assigned Remarks</div>
                                            <div className="form-info-content">
                                                <span>
                                                    {request?.new_assignment?.assigned_remark || request?.old_assignment?.assigned_remark || '-'}
                                                </span>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {(request?.estimated_cost != null || request?.vendor_name || request?.lead_time || request?.procurement_notes) && (
                <div className="tab-profile mt-3">
                    <div className="content-block">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>IT Procurement – Cost Estimate</h2>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                            <div className="form-info">
                                                <div className="form-info-label">Estimated Cost</div>
                                                <div className="form-info-content">
                                                    <span>{request?.estimated_cost != null ? request.estimated_cost : '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                            <div className="form-info">
                                                <div className="form-info-label">Vendor Name</div>
                                                <div className="form-info-content">
                                                    <span>{request?.vendor_name || '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                            <div className="form-info">
                                                <div className="form-info-label">Lead Time / Delivery Timeline</div>
                                                <div className="form-info-content">
                                                    <span>{request?.lead_time || '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                            <div className="form-info">
                                                <div className="form-info-label">Additional Notes</div>
                                                <div className="form-info-content">
                                                    <span>{request?.procurement_notes || '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                            <div className="form-info">
                                                <div className="form-info-label">Routed to Finance Head</div>
                                                <div className="form-info-content">
                                                    <span>{request?.send_to_finance ? 'Yes' : 'No'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="tab-profile mt-3">
                <div className="content-block">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2>Remark History
                                    <span className="edit float-end">
                                        <button onClick={toggleTable}
                                        className={`btn toggleData ${showHistory ? 'activeArrow' : ''}`}>
                                            <span className="material-icons-outlined">expand_more</span>
                                        </button>
                                    </span>
                                </h2>
                                {showHistory && (
                                    <div className="table-responsive tbl-main">
                                        <table className="table tbl-toggle">
                                            <thead>
                                                <tr>
                                                    <th>Actioner Name</th>
                                                    <th>Action</th>
                                                    <th>Comment</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    request?.remark_history?.length > 0 ? (
                                                        request.remark_history.map((history, index) => (
                                                            <tr key={index}>
                                                                <td>{history?.created_by_name}</td>
                                                                <td>
                                                                    <span className={statuses.find(s => s.value === history.status)?.class || 'text-secondary'}>
                                                                        {statuses.find(s => s.value === history.status)?.label || 'Unknown'}
                                                                    </span>
                                                                </td>
                                                                <td>{history?.remark}</td>
                                                                <td>
                                                                    {defaultDateFormatter(history?.created_at) ?? '-'}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : <p>No action taken yet</p>
                                                }
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default RequestDetails;